/*
  Sticky Johnson rider profile: shared behaviour for every [data-sjrp] section root
  (sections/sj-rider-*.liquid, templates/metaobject/team_riders.json).
  - Entrances: [data-sjrp-rv] children rise in, staggered, only if still below the fold, never under
    reduced motion, never left hidden. [data-sjrp-pre] roots get .is-pre until they scroll in.
  - Stats count up ([data-sjrp-count]); "Read more" jumps to About and flashes the lime bar.
  - Media tabs: a real tablist (arrows, Home/End). Photos open in a native <dialog> viewer.
  - Kit: tick items in or out, the total re-prices in the shop currency, "Add the lot" adds every ticked
    first variant in one /cart/add.js call, then updates the theme cart the way product forms do.
  - Signature gear: colourway picker swaps shot/price/links; adds the picked variant the same way.
*/
(function () {
  if (window.__sjrpLoaded) return; /* every profile section links this file; run it once */
  window.__sjrpLoaded = true;
  var reduce =window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function below(el) { return el.getBoundingClientRect().top > window.innerHeight * 0.92; }

  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NZD';
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return null; }
  }

  function countUp(el) {
    var to = parseInt(el.getAttribute('data-sjrp-count'), 10);
    if (!to || reduce) return;
    var t0 = null, dur = 900;
    function f(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(f);
    }
    el.textContent = '0';
    requestAnimationFrame(f);
  }

  function reveal(root) {
    var counters = $$('[data-sjrp-count]', root);
    if (reduce || !hasIO) return;
    var items = [];
    $$('[data-sjrp-rv]', root).forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (k, i) {
        if (!below(k)) return;
        k.classList.add('sjrp-r', 'is-wait');
        k.style.setProperty('--d', Math.min(i, 5) * 70 + 'ms');
        items.push(k);
      });
    });
    var pre = root.hasAttribute('data-sjrp-pre') && below(root) ? root : null;
    if (pre) pre.classList.add('is-pre');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove('is-wait', 'is-pre');
        if (e.target.hasAttribute('data-sjrp-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    items.forEach(function (k) { io.observe(k); });
    if (pre) io.observe(pre);
    counters.forEach(function (c) { io.observe(c); });
    /* belt and braces: never leave anything hidden */
    setTimeout(function () {
      items.forEach(function (k) { if (k.getBoundingClientRect().top < window.innerHeight * 2) k.classList.remove('is-wait'); });
      if (pre && pre.getBoundingClientRect().top < window.innerHeight * 2) pre.classList.remove('is-pre');
    }, 4000);
  }

  function readMore(root) {
    $$('[data-sjrp-more]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
        var t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        t.focus({ preventScroll: true });
        t.classList.remove('is-flash');
        setTimeout(function () {
          t.classList.add('is-flash');
          setTimeout(function () { t.classList.remove('is-flash'); }, 1400);
        }, reduce ? 0 : 450);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  }

  function tabs(root) {
    $$('[role="tablist"]', root).forEach(function (list) {
      var ts = $$('[role="tab"]', list);
      function sel(t, focus) {
        ts.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) { p.hidden = !on; p.classList.toggle('is-shown', on); }
        });
        if (focus) t.focus();
      }
      ts.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = ts[(i + 1) % ts.length];
          else if (e.key === 'ArrowLeft') n = ts[(i - 1 + ts.length) % ts.length];
          else if (e.key === 'Home') n = ts[0];
          else if (e.key === 'End') n = ts[ts.length - 1];
          if (n) { e.preventDefault(); sel(n, true); }
        });
      });
    });
  }

  function lightbox(root) {
    var dlg = root.querySelector('[data-sjrp-lb]');
    var btns = $$('[data-sjrp-photo]', root);
    if (!dlg || !btns.length || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('img'), cap = dlg.querySelector('[data-sjrp-lb-cap]'), num = dlg.querySelector('[data-sjrp-lb-n]');
    var i = 0, last = null;
    function show(n) {
      i = (n + btns.length) % btns.length;
      var b = btns[i];
      img.src = b.getAttribute('data-src');
      img.alt = b.getAttribute('data-alt') || '';
      if (cap) cap.textContent = b.getAttribute('data-alt') || '';
      if (num) num.textContent = (i + 1) + ' / ' + btns.length;
    }
    btns.forEach(function (b, n) {
      b.addEventListener('click', function () { last = b; show(n); dlg.showModal(); });
    });
    $$('[data-sjrp-lb-prev]', dlg).forEach(function (b) { b.addEventListener('click', function () { show(i - 1); }); });
    $$('[data-sjrp-lb-next]', dlg).forEach(function (b) { b.addEventListener('click', function () { show(i + 1); }); });
    $$('[data-sjrp-lb-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(i + 1);
      if (e.key === 'ArrowLeft') show(i - 1);
    });
    dlg.addEventListener('close', function () { if (last) last.focus(); });
    if (btns.length < 2) $$('[data-sjrp-lb-prev],[data-sjrp-lb-next]', dlg).forEach(function (b) { b.hidden = true; });
  }

  /* Add variants to the cart the way the theme's product form does: one /cart/add.js call (with the
     theme's grouped cart sections), then publish cartUpdate and open the cart drawer. No drawer or no
     FoxTheme: go to /cart. Shared by the kit and the signature gear. */
  function addItems(ids, btn, ok, fail) {
    var root_url = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root_url.slice(-1) !== '/') root_url += '/';
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    var body = { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    btn.classList.add('btn--loading');
    btn.setAttribute('aria-disabled', 'true');
    fetch(root_url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status) throw new Error(state.description || state.message || '');
        var drawer = document.querySelector('cart-drawer');
        if (!(window.FoxTheme && FoxTheme.pubsub) || !drawer) {
          window.location.href = root_url + 'cart';
          return;
        }
        return fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = state.sections;
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            if (ok) ok();
            if (typeof drawer.show === 'function') drawer.show(btn);
          });
      })
      .catch(function (err) { if (fail) fail(err && err.message); })
      .then(function () {
        btn.classList.remove('btn--loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  /* Signature gear (sections/sj-rider-signature.liquid): the colourway picker swaps the product shot,
     price, compare-at, product links and sold-out state; submit adds the picked variant via addItems.
     Without JS the form posts to /cart/add as a normal form. */
  function signature(root) {
    $$('[data-sjrp-sig]', root).forEach(function (form) {
      var item = form.closest('.sjrp-sig__item') || form;
      var img = item.querySelector('.sjrp-sig__img');
      var now = item.querySelector('[data-sjrp-sig-now]');
      var was = item.querySelector('[data-sjrp-sig-was]');
      var vname = item.querySelector('[data-sjrp-sig-vname]');
      var links = $$('[data-sjrp-sig-link]', item);
      var btn = form.querySelector('[data-sjrp-sig-add]');
      var label = btn && btn.querySelector('[data-sjrp-sig-label]');
      var msg = form.querySelector('[data-sjrp-sig-msg]');
      var select = form.querySelector('select[name="id"]');
      function current() {
        if (select) return select.options[select.selectedIndex];
        return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      }
      function apply() {
        var el = current();
        if (!el || !el.hasAttribute('data-now')) return;
        var avail = el.getAttribute('data-available') === 'true';
        if (now) now.textContent = el.getAttribute('data-now');
        if (was) { var w = el.getAttribute('data-was'); was.textContent = w || ''; was.hidden = !w; }
        if (vname) vname.textContent = el.getAttribute('data-title') || '';
        var url = el.getAttribute('data-url');
        if (url) links.forEach(function (a) { a.setAttribute('href', url); });
        var src = el.getAttribute('data-src');
        if (img && src && img.getAttribute('src') !== src) {
          img.classList.remove('is-swap');
          void img.offsetWidth;
          img.setAttribute('srcset', el.getAttribute('data-srcset') || src);
          img.setAttribute('src', src);
          img.classList.add('is-swap');
        }
        if (btn) {
          btn.disabled = !avail;
          if (label) label.textContent = avail ? btn.getAttribute('data-add') : btn.getAttribute('data-sold');
        }
        if (msg) msg.textContent = '';
      }
      form.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') apply(); });
      form.addEventListener('submit', function (e) {
        var el = current();
        if (!el || !btn) return;
        e.preventDefault();
        if (btn.disabled || btn.classList.contains('btn--loading')) return;
        if (msg) msg.textContent = '';
        addItems([parseInt(el.value, 10)], btn, function () {
          if (msg) msg.textContent = form.getAttribute('data-added') || '';
        }, function (m) {
          if (msg) msg.textContent = m || form.getAttribute('data-error') || '';
        });
      });
    });
  }

  function kit(root) {
    var box = root.querySelector('[data-sjrp-kit]');
    if (!box) return;
    var checks = $$('[data-sjrp-kit-item]', box);
    var btn = box.querySelector('[data-sjrp-kit-add]');
    var label = btn && btn.querySelector('[data-sjrp-kit-label]');
    var total = box.querySelector('[data-sjrp-kit-total]');
    var count = box.querySelector('[data-sjrp-kit-count]');
    var msg = box.querySelector('[data-sjrp-kit-msg]');
    if (!btn) return;
    var d = btn.dataset;

    function picked() { return checks.filter(function (c) { return c.checked && !c.disabled; }); }
    function update() {
      var on = picked(), cents = 0;
      checks.forEach(function (c) {
        var row = c.closest('.sjrp-kit__item');
        if (row) row.classList.toggle('is-off', !c.checked || c.disabled);
        if (c.checked && !c.disabled) cents += parseInt(c.getAttribute('data-price'), 10) || 0;
      });
      var m = money(cents);
      if (total && m) total.textContent = m;
      if (count) count.textContent = (on.length === 1 ? d.one : d.many || '').replace('[count]', on.length);
      var avail = checks.filter(function (c) { return !c.disabled; }).length;
      if (label) label.textContent = avail === 1 && d.single ? d.single : on.length === avail ? d.all : (d.some || d.all).replace('[count]', on.length);
      btn.disabled = !on.length;
    }
    checks.forEach(function (c) { c.addEventListener('change', update); });

    function say(t) { if (msg) msg.textContent = t || ''; }

    btn.addEventListener('click', function () {
      var on = picked();
      if (!on.length || btn.classList.contains('btn--loading')) return;
      say('');
      addItems(on.map(function (c) { return parseInt(c.value, 10); }), btn, function () {
        say((d.added || '').replace('[count]', on.length));
      }, function (m) { say(m || d.error); });
    });
    update();
  }

  function init(root) {
    if (root.__sjrp) return;
    root.__sjrp = true;
    reveal(root);
    readMore(root);
    tabs(root);
    lightbox(root);
    kit(root);
    signature(root);
  }
  function all() { $$('[data-sjrp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* Reels (sections/sj-rider-reels.liquid): Instagram's embed posts its real height ({type:'MEASURE'});
   size each iframe to it so there's no blank band under the player. The CSS height is the fallback. */
(function () {
  if (window.__sjrpReels) return;
  window.__sjrpReels = true;
  window.addEventListener('message', function (e) {
    if (!/(^|\.)instagram\.com$/.test((e.origin || '').replace(/^https?:\/\//, ''))) return;
    var data = e.data;
    try { if (typeof data === 'string') data = JSON.parse(data); } catch (err) { return; }
    if (!data || data.type !== 'MEASURE' || !data.details || !data.details.height) return;
    var frames = document.querySelectorAll('.sjrp-reel__frame');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === e.source) { frames[i].style.height = Math.ceil(data.details.height) + 'px'; break; }
    }
  });
})();
